import type React from "react";
import {useAuthState} from "react-firebase-hooks/auth";
import {useNavigate} from "react-router-dom";

import {faCalendarAlt, faClock} from "@fortawesome/free-solid-svg-icons";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";

import {
  useRealtimeWipLevelsV2,
  useWipLevelsV2,
} from "~/api/hooks/useWipLevelV2";
import AppHeader from "~/component/common/AppHeader";
import CustomButton from "~/component/common/CustomButton";
import TimeSince from "~/component/common/TimeSince";
import useLevelLoader from "~/contexts/loader/useLevelLoader";
import {auth} from "~/firebase/firebase";
import CreateLevelModalButton from "~/routes/page/create/create-new/CreateLevelModalButton";

const Create: React.FC = () => {
  const navigate = useNavigate();
  const [user] = useAuthState(auth);
  const load = useLevelLoader();

  const {data: wipLevels} = useWipLevelsV2({
    key: {},
    filters: [
      {fieldPath: "creatorId", opStr: "==", value: user?.uid ?? "unknown"},
    ],
    sort: [{fieldPath: "updatedAt", direction: "desc"}],
    limit: 100,
  });
  useRealtimeWipLevelsV2({
    key: {},
    filters: [
      {fieldPath: "creatorId", opStr: "==", value: user?.uid ?? "unknown"},
    ],
    sort: [{fieldPath: "updatedAt", direction: "desc"}],
    limit: 100,
  });

  return (
    <div className="flex flex-col w-screen min-h-screen overflow-auto relative text-white bg-transparent">
      <AppHeader title="Create" />
      <main className="mt-16 px-2 pb-4 flex-1 z-20">
        <div className="flex flex-wrap gap-2 justify-center">
          <CreateLevelModalButton />
          {(wipLevels || []).map((level) => (
            <CustomButton
              key={level.id}
              onMouseEnter={() => load(level.id, level)}
              onTouchStart={() => load(level.id, level)}
              onClick={() => navigate(`/create/${level.id}`)}
              className="w-[200px] cursor-pointer bg-gradient-to-b from-black/50 to-indigo-900/50 rounded-lg p-2 shadow-sm transition duration-300 hover:from-black/90 hover:to-indigo-900/90 text-left"
            >
              <h2 className="text-white text-lg font-normal mb-1 truncate">
                {level.name}
              </h2>
              <p className="text-gray-300 text-xs flex flex-col gap-0.5">
                <span className="flex items-center">
                  <FontAwesomeIcon icon={faCalendarAlt} className="mr-1" />
                  <TimeSince date={level.createdAt} />
                </span>
                <span className="flex items-center">
                  <FontAwesomeIcon icon={faClock} className="mr-1" />
                  <TimeSince date={level.updatedAt} />
                </span>
              </p>
            </CustomButton>
          ))}
        </div>
      </main>
    </div>
  );
};

export default Create;
